import { createAction, props } from "@ngrx/store";
import { CreateTaskRequestDto } from "src/app/shared/models/ClickUp/createTaskRequestDto";
import { SuccessDto } from "src/app/shared/models/success-dto";

export const invokeCreateClickUpTask = createAction(
  "[ Invoke create task ] Invoke create task",
  props<{createTask: CreateTaskRequestDto}>()
);

export const resultCreateClickUpTask = createAction(
    "[ Result create task ] Result create task",
    props<{result: SuccessDto | null}>()
)